import { isNative } from '../utils/platform';

let initialized = false;

export async function initPushNotifications(registerToken) {
  if (!isNative || initialized) return;
  initialized = true;

  const { PushNotifications } = await import('@capacitor/push-notifications');

  const permission = await PushNotifications.requestPermissions();
  if (permission.receive !== 'granted') return;

  await PushNotifications.register();

  // Send device token to backend when registration succeeds
  PushNotifications.addListener('registration', async ({ value: token }) => {
    try {
      await registerToken(token);
    } catch (err) {
      console.error('Failed to register push token:', err);
    }
  });

  PushNotifications.addListener('registrationError', (err) => {
    console.error('Push registration error:', err);
  });

  // Handle notification tap — navigate to the relevant page
  PushNotifications.addListener('pushNotificationActionPerformed', ({ notification }) => {
    const data = notification.data || {};
    let path = '/dashboard';
    if (data.type === 'concert_alert') path = '/concerts';
    else if (data.type === 'group_activity' && data.group_id) path = `/groups/${data.group_id}`;
    else if (data.type === 'leaderboard') path = '/leaderboards';
    else if (data.type === 'festival') path = '/festival';
    else if (data.url) path = data.url;

    window.history.pushState({}, '', path);
    window.dispatchEvent(new PopStateEvent('popstate'));
  });
}
